import { render, staticRenderFns } from "./nine.vue?vue&type=template&id=d20454da&"
import script from "./nine.vue?vue&type=script&lang=js&"
export * from "./nine.vue?vue&type=script&lang=js&"
import style0 from "./nine.vue?vue&type=style&index=0&id=d20454da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports